var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"dark":"","size":_vm.size,"color":_vm.getColor}},[_vm._v("close")])}
var staticRenderFns = []

export { render, staticRenderFns }